// src/components/Topbar.jsx
import React from "react";

export default function Topbar({ auth, handleLogout }) {
  return (
    <header className="sticky top-0 z-10 bg-white/90 backdrop-blur border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* Logo KOPKAR CWI */}
          <img
            src="/logo-kopkar.jpeg"
            alt="Logo KOPKAR CWI"
            className="w-10 h-10 object-contain"
          />
          <div>
            <p className="text-sm text-slate-500 leading-tight">
              Koperasi Simpan Pinjam
            </p>
            <h1 className="text-base font-semibold">PT.Crown Worldwide Indonesia</h1>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="hidden md:flex flex-col items-end">
            <span className="text-sm font-medium">{auth.user?.name}</span>
            <span className="text-[11px] text-slate-400 capitalize">
              {auth.user?.role}
            </span>
          </div>
          <button
            onClick={handleLogout}
            className="text-xs px-3 py-1.5 rounded-xl border text-slate-500 hover:bg-slate-50"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}